<!-- 医生卡片 -->
<template>
  <div
    :class="[{ active: isActived }, 'card']"
    @click="handleClick"
    @mouseenter="handleMouseEnterDoctor()"
  >
    <div class="content">
      <div class="header z-flex">
        <div class="left">
          <div class="name">{{ info.name }}</div>
          <div class="level">
            {{ info.departmentName }}
            <span>{{ info.titleName }}</span>
          </div>
        </div>
        <div class="right">
          <a-avatar
            class="avatar"
            size="large"
            :src="info.headUrl || head_d"
            shape="square"
            alt="头像"
          />
        </div>
      </div>
      <div class="organization">
        <span class="grade" v-if="info.levelType">{{ info.levelType }}</span>
        {{ info.hospitalName }}
      </div>
      <div class="excel">
        <div class="desc">
          <span class="have">擅长：</span>
          {{ info.expertise || '--' }}
        </div>
        <div style="margin-top: 4px" v-if="info?.doctorSkillTags?.length > 0">
          <docTags :tags="info?.doctorSkillTags || []"></docTags>
        </div>
      </div>
      <div class="remark" v-if="info.synergyRemark">
        <span class="have">协同备注：</span>
        <a-tooltip>
          <template #title>{{ info.synergyRemark }}</template>
          <div class="descText">{{ info.synergyRemark }}</div>
        </a-tooltip>
      </div>
    </div>
    <div class="footer">
      <auth-img class="location" :src="location" alt="" />
      {{ info.address }}
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, defineEmits } from 'vue'
import location from '@/assets/img/chat/location.png'
import head_d from '@/assets/img/chat/head_d.png'
import docTags from './docTags.vue'

const props = defineProps({
  info: {
    type: Object,
    default: () => {},
    required: true
  },
  selectedList: {
    type: Array,
    default: () => [],
    required: true
  }
})
const isActived = computed(() => props.selectedList.includes(props.info.id))
const emit = defineEmits(['select', 'getRecommendDoctorInfo'])

const handleClick = () => {
  emit('select', props.info.id, props.info)
}

// 鼠标移入医生卡片
const handleMouseEnterDoctor = () => {
  emit('getRecommendDoctorInfo', props.info)
}
</script>
<style scoped lang="scss">
%light-font {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
}
%normal-font {
  font-size: 12px;
  font-weight: 400;
  color: #3b3b3b;
}
.card:hover {
  background: rgba(24, 144, 255, 0.08);
}
.card {
  display: flex;
  flex-direction: column;
  border: 1px solid transparent;
  &.active {
    border: 1px solid #1890ff;
    background: rgba(24, 144, 255, 0.08);
  }
  cursor: pointer;
  border-radius: 8px;
  background: #f7f7f7;

  .content {
    padding: 12px 16px;
    flex: 1;
  }
  .header {
    // align-items: ;
    margin-bottom: 18px;
    .left {
      .name {
        font-weight: 500;
        font-size: 14px;
        color: #1a1a1a;
      }
      .level {
        @extend %light-font;
        span {
          border-left: 1px solid #999999;
          padding-left: 6px;
          margin-left: 4px;
        }
      }
    }
    .right {
      border-radius: 4px;
      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }
    }
  }
  .organization {
    @extend %normal-font;
    .grade {
      padding: 2px 4px;
      font-weight: 500;
      font-size: 10px;
      color: #ffffff;
      background: #1890ff;
      border-radius: 4px;
      margin-right: 4px;
    }
  }
  .excel {
    margin-top: 13px;
    .desc {
      @extend %normal-font;
      overflow: hidden;
      text-overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      .have {
        font-weight: 500;
      }
    }
  }

  .remark {
    margin-top: 8px;
    @extend %normal-font;
    display: flex;
    .have {
      font-weight: 500;
      min-width: 75px;
    }
  }

  .descText {
    color: #f78408;
    width: fit-content;
    display: inline-block;
    overflow: hidden;
    text-overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .footer {
    padding: 6px 17px;
    @extend %light-font;
    border-top: 1px solid rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    .location {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
  }
}
</style>
